@if (!!data) {
<div class="messaging-timeline">
  <div class="messaging-timeline__header">
    <span class="messaging-timeline__header__title"
      >Histórico de la comunicación</span
    >
    <button mat-icon-button (click)="dialogRef.close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="messaging-timeline__container">
    @if (hasError()) {
    <div class="messaging-timeline__message">
      <app-horus-message-general
        nameIcon="errorMessageIcon"
        btnAction="INTENTAR NUEVAMENTE"
        (action)="loadMessagingData()"
      >
        <span style="color: #f14b26; font-size: 14px; line-height: 25px"
          >Lo sentimos</span
        ><br />
        Hubo un <strong>error al intentar cargar</strong> el histórico de la
        comunicación.
      </app-horus-message-general>
    </div>
    } @else if (!isLoading() && messageDetail().length > 0) {
    <div class="messaging-timeline__body">
      <div class="messaging-timeline__body__top">
        <app-message-type-label
          [messageType]="data.messageType"
        ></app-message-type-label>
      </div>

      <div class="messaging-timeline__body__content">
        <div class="timeline">
          <div
            class="timeline__step"
            *ngFor="
              let item of messageDetail();
              let i = index;
              let first = first
            "
            [ngClass]="{ 'timeline__step--active': item.active }"
          >
            <div class="timeline__step__icon">
              <div class="timeline__step__circle">
                <mat-icon>{{
                  item.active ? "check" : "radio_button_unchecked"
                }}</mat-icon>
              </div>
              <div class="timeline__step__line" *ngIf="!first"></div>
            </div>

            <div class="timeline__step__content">
              <div class="timeline__step__title">
                {{ i + 1 }}. {{ item.statusName }}
              </div>

              @if (item.createdAt && isLastActive(i)) {
              <div class="timeline__step__description">
                {{ item.statusDescription }}
              </div>
              <div class="timeline__step__timestamp">
                {{ item.createdAt }}
              </div>
              }
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="messaging-timeline__footer">
      <div class="messaging-timeline__footer__options">
        <button
          horusBtn
          horusBtnSize="md"
          class="w-full"
          (click)="openMessagingResendDialog($event)"
        >
          REENVIAR COMUNICACIÓN
        </button>
        <button
          horusBtn
          horusBtnVariant="outline-default"
          horusBtnSize="md"
          class="w-full"
          (click)="dialogRef.close()"
        >
          CANCELAR
        </button>
      </div>
    </div>
    } @else {
    <div
      class="messaging-timeline__message messaging-timeline__message--loading"
    >
      <app-horus-loading size="S"></app-horus-loading>
    </div>
    }
  </div>
</div>

}
